import { render } from "./formrow.vue?vue&type=template&id=57645278"
import script from "./formrow.vue?vue&type=script&lang=js"
export * from "./formrow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__